module.exports = __webpack_public_path__ + "static/img/icon07.5638c275.svg";